import React from 'react';
import MultichoixStepHeader from './MultichoixStepHeader';
import MultichoixStepContent from './MultichoixStepContent';

const MultichoixStep = ({
  step,
  status,
  isActive,
  canClick,
  selections,
  selectionLabels,
  isCompleted,
  isValid,
  isRequired,
  allSelections,
  allLabels,
  onStepClick,
  onChange,
  onNext,
  onSkip,
  onForceRevalidation,
  mode,
}) => {
  return (
    <div className={`step-container ${isActive ? 'border border-[#7cb305] rounded-[16px]' : ''}`}>
      <MultichoixStepHeader
        step={step}
        status={status}
        isActive={isActive}
        canClick={canClick}
        selections={selections}
        selectionLabels={selectionLabels}
        isCompleted={isCompleted}
        onClick={() => canClick && onStepClick(step.key)}
      />
      <MultichoixStepContent
        step={step}
        isActive={isActive}
        value={selections}
        isValid={isValid}
        isRequired={isRequired}
        allSelections={allSelections}
        allLabels={allLabels}
        onChange={onChange}
        onNext={onNext}
        onSkip={onSkip}
        onForceRevalidation={onForceRevalidation}
        selectionLabels={selectionLabels}
        mode={mode}
      />
    </div>
  );
};

export default MultichoixStep;
